import { render, staticRenderFns } from "./AreaUnit.vue?vue&type=template&id=3aac1f0e"
import script from "./AreaUnit.vue?vue&type=script&lang=js"
export * from "./AreaUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports